import React, { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';

import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import sliderData from "./SliderData";

const slider = new Array(sliderData)

const MobileHomeSlider = () => (

    <div className="mobileSliderContent">



        <div className='slide_item' style={Object.assign({})}>
            <div className='mobile_hbutton'>
                <Button
                    variant="outline-light"
                    href={sliderData[0].urlm}
                >
                    <div className='slide_image'><img src={sliderData[0].image} /></div>
                    <div className='mobile_preinfo'><h1>{sliderData[0].title}</h1></div>


                </Button>

            </div>

        </div>


        <div className='slide_item' style={Object.assign({})}>
            <div className='mobile_hbutton'>
                <Button
                    variant="outline-light"
                    href={sliderData[1].urlm}
                >
                    <div className='slide_image'><img src={sliderData[1].image} /></div>
                    <div className='mobile_preinfo'><h1>{sliderData[1].title}</h1></div>



                </Button>
            </div>

        </div>

        <div className='slide_item' style={Object.assign({})}>
            <div className='mobile_hbutton'>
                <Button
                    variant="outline-light"
                    href={sliderData[2].urlm}
                >
                    <div className='slide_image'><img src={sliderData[2].image} /></div>
                    <div className='mobile_preinfo'><h1>{sliderData[2].title}</h1></div>



                </Button>
            </div>

        </div>

        <div className='slide_item' style={Object.assign({})}>
            <div className='mobile_hbutton'>
                <Button
                    variant="outline-light"
                    href={sliderData[3].urlm}
                >
                    <div className='slide_image'><img src={sliderData[3].image} /></div>
                    <div className='mobile_preinfo'><h1>{sliderData[3].title}</h1></div>


                </Button>
            </div>

        </div>


    </div>

);

export default MobileHomeSlider;